import { axiosObject } from "../config";

function getCities() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/cities/_read";
    let payload = {
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllCities() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/cities/_read";
    let payload = {
      limitBy: {
        per_page: 20000,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "deleted_at",
          op: "is",
          value: null,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllCitiesByStates(state: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/cities/_read";
    let payload = {
      limitBy: {
        per_page: 20000,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "deleted_at",
          op: "is",
          value: null,
        },
        {
          attribute: "state",

          value: state,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getCity(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/cities/_read";
    let payload = {
      filterBy: [
        {
          attribute: "slug",
          op: "eq",
          value: data.slug,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getCities, getCity, getAllCities, getAllCitiesByStates };
